// From Highcharts 12 a module registers itself on import onto whichever of
// highcharts, highstock or highmaps was loaded last on the page. Charts
// importing those separately would leave all but one namespace without these
// modules, so every chart shares this one: Highstock plus the map module.
// Exporting downloads PNGs in the browser by default since 12.3, so the
// offline-exporting module (now PDF-only) isn't needed.
import Highcharts from 'highcharts/highstock';
import 'highcharts/modules/map';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/exporting';

// Highcharts 13 dates follow the page language ("en" gives US month-first
// order) and its colours follow the OS dark mode. en-GB keeps the day-month
// order the charts had before 13, and Explorer has no dark theme.
Highcharts.setOptions({ lang: { locale: 'en-GB', thousandsSep: ',' }, palette: { colorScheme: 'light' } });

// Highcharts 13 fades destroyed points out, wiping them on a timer but keeping
// them on their series until it next redraws. Data grouping replaces every
// point on each zoom or post-type toggle, so showing a hidden series, or moving
// the mouse mid-fade, can reach a wiped point and throw. Destroying points
// immediately avoids that; the columns replacing them still animate in.
Highcharts.wrap(Highcharts.Point.prototype, 'destroy', function (proceed) {
  return proceed.call(this, true);
});

export default Highcharts;
